module.exports = __webpack_public_path__ + "img/美容水(绿)_03.122392c8.jpg";